import Vue from 'vue'
import Vuex from 'vuex'
import {API_ENDPOINT, AUTH_TOKEN} from "../constants";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        emailaddress: '',
        messages: [],
    },

    getters: {
        getEmailAddress: state => {
            return state.emailaddress
        },
        getEmailDetailByIndex: state => (index) => {
            return state.messages[index]
        }
    },

    mutations: {
        SET_EMAIL(state, email) {
            state.emailaddress = email
        },

        SET_MESSAGES(state, payload) {

            state.messages = payload.results

        },
        UNSET_MESSAGES(state) {
            state.messages = []
        },
        SET_AUTH_TOKEN() {
            localStorage.setItem(AUTH_TOKEN, AUTH_TOKEN)
        },
        SET_BODY_MESSAGE(state, {index, json}) {
            state.messages[index].html_body = json
        }
    },

    actions: {
        async fetchMessages({commit}, email) {
            try {
                const response = await fetch(API_ENDPOINT + '/messages?email='+email+'&token='+localStorage.getItem(AUTH_TOKEN), {
                    method: 'GET',
                })

                const json = await response.json()
                if (response.status>=200 && response.status<300) {
                    commit('SET_MESSAGES', json)
                } else {
                    commit('UNSET_MESSAGES')
                    throw new Error(json.message)
                }
            } catch (err) {
                commit('UNSET_MESSAGES')
                throw new Error(err)
            }
        },

        async fetchEmailBody({commit}, {email, id, index}) {
            try {
                const response = await fetch(API_ENDPOINT + '/message?email='+email+'&id='+id+'&token='+localStorage.getItem(AUTH_TOKEN), {
                    method: 'GET',
                })

                const json = await response.json()
                if (response.status>=200 && response.status<300) {
                    commit('SET_BODY_MESSAGE', {index, json})
                } else {
                    throw new Error(json.message)
                }
            } catch (err) {
                throw new Error(err)
            }
        },
    },

})